import palette from 'constants/palette'
import React from 'react'

// "Without Live Updates" corner badge (Overview hero's before/after phone
// comparison) — a filled red circle + white X, the Checkmark sibling's
// negative counterpart.
const CrossCircleFilled = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill={palette.cayenne} />
    <path
      d="M6.5 6.5l7 7M13.5 6.5l-7 7"
      stroke={palette.white}
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
)

export default CrossCircleFilled
